import {
  ClientChainControllerGetChainInformationApiArg,
  ClientChainControllerGetChainInformationApiResponse,
  ClientReservationByUrlIntegrationControllerGetIntegrationApiArg,
  ClientReservationByUrlIntegrationControllerGetIntegrationApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const chainApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getChainInformation: build.query<
      ClientChainControllerGetChainInformationApiResponse,
      ClientChainControllerGetChainInformationApiArg
    >({
      query: () => 'chain/information',
    }),
    getReservationByUrl: build.query<
      ClientReservationByUrlIntegrationControllerGetIntegrationApiResponse,
      ClientReservationByUrlIntegrationControllerGetIntegrationApiArg
    >({
      query: () => ({ url: `integrations/reservation-by-url` }),
    }),
  }),
});

export const { useGetChainInformationQuery, useGetReservationByUrlQuery } = chainApi;
